import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { ProcessSteps } from "@/components/ProcessSteps";
import { Reveal } from "@/components/Reveal";
import { CTABand } from "@/components/CTABand";
import { BUSINESS } from "@/data/content";
import { Placeholder } from "@/components/Placeholder";

const NOTES = [
  { title: "Communication", text: "Progress is reported in plain English at the intervals stated in your quotation — by email, telephone or video call. You always have a named point of contact." },
  { title: "Revisions", text: "Each quotation states the number of revision rounds included at each stage. Requests outside the agreed scope are quoted separately before the work is done." },
  { title: "Delivery", text: "Deliverables are provided digitally. Websites are deployed to hosting in your name; documents and plans are delivered as editable files you own." },
  { title: "Changes & cancellation", text: "Either party may raise a change in scope at any time. Cancellation terms are set out in the quotation and in our Refund & Cancellation Policy." },
];

export default function Process() {
  return (
    <div data-testid="process-page">
      <Seo title="Our Process" description="How an engagement with My Geeks LLC works, from first enquiry to written quotation, delivery, revisions and handover." />
      <PageHeader overline="Our process" title="How an engagement works" lede="Six steps, the same for every project. You know what happens next at every stage, and nothing is built or billed without your written agreement." />
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-20">
        <ProcessSteps />
        <Reveal delay={0.1}>
          <p data-testid="process-response-time" className="mt-8 text-sm leading-relaxed text-slate-600">
            Expected response to a new enquiry: <Placeholder field={BUSINESS.responseTime} /> during business hours (<Placeholder field={BUSINESS.hours} />).
          </p>
        </Reveal>
      </section>

      <section className="border-y border-slate-200 bg-cream">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-24">
          <Reveal>
            <p className="eyebrow">Working together</p>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">What to expect along the way</h2>
          </Reveal>
          <div className="mt-10 grid gap-5 md:grid-cols-2">
            {NOTES.map((n, i) => (
              <Reveal key={n.title} delay={i * 0.06} className="h-full">
                <div data-testid={`process-note-${i + 1}`} className="card h-full p-7">
                  <h3 className="font-display text-lg font-semibold tracking-tight">{n.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">{n.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand title="Start at step one." text="Send an enquiry and we'll arrange a short discovery call." />
    </div>
  );
}
